/**
 * @generated SignedSource<<94c456934fad4aea11dd3314df1da9d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookScrapDeleteInput = {
  id: string;
};
export type BookBookScrapDeleteDialog_bookScrapDeleteMutation$variables = {
  input: BookScrapDeleteInput;
};
export type BookBookScrapDeleteDialog_bookScrapDeleteMutation$data = {
  readonly bookScrapDelete: {
    readonly book: {
      readonly id: string;
      readonly unclassifiedBookScrapCount: number;
    };
    readonly id: string;
  };
};
export type BookBookScrapDeleteDialog_bookScrapDeleteMutation = {
  response: BookBookScrapDeleteDialog_bookScrapDeleteMutation$data;
  variables: BookBookScrapDeleteDialog_bookScrapDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BookScrap",
    "kind": "LinkedField",
    "name": "bookScrapDelete",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Book",
        "kind": "LinkedField",
        "name": "book",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unclassifiedBookScrapCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookBookScrapDeleteDialog_bookScrapDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookBookScrapDeleteDialog_bookScrapDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "10cd9f01dad5e493c00eebc17bd89562",
    "id": null,
    "metadata": {},
    "name": "BookBookScrapDeleteDialog_bookScrapDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BookBookScrapDeleteDialog_bookScrapDeleteMutation(\n  $input: BookScrapDeleteInput!\n) {\n  bookScrapDelete(input: $input) {\n    id\n    book {\n      id\n      unclassifiedBookScrapCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6acc2bb371a5c87a626946553ad5cf3";

export default node;
